import { Box, TextField } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import { useLocation } from "react-router-dom";

const ViewClosedDispute = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const location = useLocation();

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header
            title="VIEW DISPUTE"
            subtitle="View a closed dispute details"
          />

          <Formik>
            {() => (
              <form>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    type="text"
                    label="Contract Code"
                    value={location.state.closedDisputeDetails.contractCode}
                    name="contractCode"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Subject Name"
                    value={location.state.closedDisputeDetails.subjectName}
                    name="subjectName"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Created Date"
                    value={location.state.closedDisputeDetails.created}
                    name="created"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Resolved Date"
                    value={location.state.closedDisputeDetails.resolved}
                    name="resolved"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Status"
                    value={location.state.closedDisputeDetails.status}
                    name="status"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Age"
                    value={location.state.closedDisputeDetails.age}
                    name="age"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Age Definition"
                    value={location.state.closedDisputeDetails.ageDefinition}
                    name="ageDefinition"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Subscriber Name"
                    value={location.state.closedDisputeDetails.subscriberName}
                    name="subscriberName"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                  <TextField
                    fullWidth
                    type="text"
                    label="Comments"
                    value={location.state.closedDisputeDetails.comments}
                    name="comments"
                    sx={{ gridColumn: "span 2" }}
                    disabled
                  />
                </Box>
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

export default ViewClosedDispute;
